import React from "react";
import SubNavMenu from "../shared/subNavMenu";
import GridLightIcon from "../../images/icons/fi-rr-grid-light.inline.svg";
import GridDarkIcon from "../../images/icons/fi-rr-grid-dark.inline.svg";
import { navigate } from "gatsby";

const MenuOnline = ({ menuItems, colorMode, children }) => {
  return (
    <section className="bg-yellow-lighter planet:bg-gray-darker fixed w-full top-16 z-10 flex justify-center py-10 h-100 md:overflow-y-scroll lg:overflow-y-hidden">
      <div className="container flex w-10/12 flex-wrap lg:flex-nowrap">
        <div className="w-full lg:w-9/12 border-l-0 mr-12">
          <div className="w-full gvi-dark-gray-color border-b pb-3 border-border-light planet:border-gray-lighter">
            <span className="h5 uppercase text-white active-link !px-0 pb-3">
              Online & Virtual
            </span>
          </div>
          <div className="w-full flex mt-11 border-b gvi-dark-gray-color pb-6 border-border-light planet:border-black-light">
            <div className="w-4/12 flex flex-col pr-8">
              <button
                className="flex px-8 py-2 bg-white planet:bg-gray-standard justify-center mb-6 items-center w-52 rounded-full planet:rounded-xxs"
                onClick={() => navigate("/find-a-program/")}
              >
                {colorMode === "light" ? <GridLightIcon /> : <GridDarkIcon />}
                <span className="pl-2 font-semibold text-base text-black-lighter planet:text-white tracking-[0.02em]">
                  Find a program
                </span>
              </button>

              {menuItems?.slice(0, 1).map((menu, index) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={menu?.cssClasses.join(" ")}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={index}
                  />
                );
              })}
            </div>
            <div className="w-4/12 flex flex-col pr-4">
              {menuItems?.slice(1, 2).map((menu, index) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={menu?.cssClasses.join(" ")}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={index}
                  />
                );
              })}
            </div>
            <div className="w-4/12 flex flex-col">
              {menuItems?.slice(2, 3).map((menu, index) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={menu?.cssClasses.join(" ")}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={index}
                  />
                );
              })}
            </div>
          </div>
          <div className="w-full mt-5 flex">
            <div className="w-4/12 pr-4">
              {menuItems?.slice(3, 4).map((menu, index) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={menu?.cssClasses.join(" ")}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={index}
                  />
                );
              })}
            </div>
            <div className="w-4/12 flex flex-col pr-8">
              {menuItems?.slice(4, 5).map((menu, index) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={menu?.cssClasses.join(" ")}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={index}
                  />
                );
              })}
            </div>
            <div className="w-4/12 flex flex-col pr-8">
              {menuItems?.slice(5, 6).map((menu, index) => {
                return (
                  <SubNavMenu
                    subTitle={menu.label}
                    subTitleClass={menu?.description}
                    subtitleLink={menu?.path ?? menu?.url}
                    className={menu?.cssClasses.join(" ")}
                    data={menu?.children?.nodes ?? menu?.children}
                    key={index}
                  />
                );
              })}
            </div>
          </div>
        </div>

        <div className="w-full pt-4 pb-16 lg:pt-0 lg:w-3/12">{children}</div>
      </div>
    </section>
  );
};

export default MenuOnline;
